/* unplugin-vue-components disabled */import { render } from "./lifecycle-emitter.vue?vue&type=template&id=5e6b868b"
import script from "./lifecycle-emitter.vue?vue&type=script&lang=js"
export * from "./lifecycle-emitter.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/lifecycle-emitter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e6b868b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e6b868b', __exports__)) {
    api.reload('5e6b868b', __exports__)
  }
  
  module.hot.accept("./lifecycle-emitter.vue?vue&type=template&id=5e6b868b", () => {
    api.rerender('5e6b868b', render)
  })

}


export default __exports__